export function isValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime());
}

// 领取后优惠券写入缓存 3分钟
export const receiveExpirationTimeRange = 12 * 60 * 60 * 1000;

export function setReceiveCouponCache(couponId, expirationTimeRange = receiveExpirationTimeRange) {
    const userId = window.localStorage.getItem('userId');
    let receiveIds = JSON.parse(window.localStorage.getItem('receiveIds') || '[]') || [];
    let index = -1;
    if (Array.isArray(receiveIds)) {
        index = receiveIds.findIndex(e => e.userId == userId);
        if (index > -1) {
            let ids = receiveIds[index].ids || [];
            const receiveExpirationTime = new Date().getTime() + expirationTimeRange;
            const couponIndex = ids.findIndex(couponCache => couponCache.couponId == couponId);
            if (couponIndex == -1) {
                ids.push({ couponId, expirationTime: receiveExpirationTime });
            } else {
                ids[couponIndex].expirationTime = receiveExpirationTime;
            }
            receiveIds[index].ids = ids;
        } else {
            receiveIds.push(createReceiveIds(userId, couponId, expirationTimeRange));
        }
    } else {
        receiveIds = [createReceiveIds(userId, couponId, expirationTimeRange)];
    }
    window.localStorage.setItem('receiveIds', JSON.stringify(receiveIds));
}
export function createReceiveIds(userId, couponId, expirationTimeRange = receiveExpirationTimeRange) {
    const ids = [{ couponId, expirationTime: new Date().getTime() + expirationTimeRange }];
    return {
        userId,
        ids,
    };
}
export function uniqueIds(arr) {
    return [...new Set(arr)];
}

// 判断是否已领取
export function checkIsReceiveCoupon(coupon) {
    const userId = window.localStorage.getItem('userId');
    const receiveIds = JSON.parse(window.localStorage.getItem('receiveIds') || '[]') || [];
    const myReceiveIds = receiveIds.find(e => e.userId == userId);
    const ids = myReceiveIds != null ? myReceiveIds.ids : [];
    if (ids) {
        const couponCacheData = ids.find(couponCache => couponCache.couponId == coupon.couponId);
        if (couponCacheData && new Date().getTime() < couponCacheData.expirationTime) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

// 库存为空缓存 5分钟
const emptyExpirationTimeRange = 5 * 60 * 1000;
export function receiveEmptyResult(couponId) {
    let emptyCouponList = JSON.parse(window.localStorage.getItem('emptyCouponList') || '[]') || [];
    const expirationTime = new Date().getTime() + emptyExpirationTimeRange;
    const index = emptyCouponList.findIndex(coupon => coupon.couponId == couponId);
    if (index > -1) {
        // 更新时间
        emptyCouponList[index].expirationTime = expirationTime;
    } else {
        emptyCouponList.push({ couponId, expirationTime: expirationTime });
    }
    window.localStorage.setItem('emptyCouponList', JSON.stringify(emptyCouponList));
}

// 根据缓存时间判断优惠券是否过期
export function checkIsEmptyCoupon(couponId) {
    let emptyCouponList = JSON.parse(window.localStorage.getItem('emptyCouponList') || '[]') || [];
    const couponCache = emptyCouponList.find(coupon => {
        return coupon.couponId == couponId;
    });
    if (couponCache) {
        if (new Date().getTime() < couponCache.expirationTime) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
